import {Dispatch, FC, SetStateAction} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {FormAvailability} from '../Forms/FormAvailability'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
}

const ModalAvailability: FC<Props> = ({show, setShow}) => {
  const handleClose = () => {
    setShow(false)
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Disponibilidad</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormAvailability />
        </div>
      </div>
    </Modal>
  )
}

export {ModalAvailability}
